module.exports = __webpack_public_path__ + "img/DTE_20220514.8fd91bc3.png";